// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"DownloadApp_imageContainer__wDpfq","mobileLinks":"DownloadApp_mobileLinks__7E9oF","img":"DownloadApp_img__6pKM9"};